/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTwitchAuthSchema = z.object({
  userId: z.string().nullish(),
  twitchId: z.string().min(1),
  login: z.string().min(1),
  accessToken: z.string().nullish(),
  refreshToken: z.string().nullish(),
  tokenExpiry: z.iso.datetime().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  updatedAt: z.optional(z.iso.datetime()),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
});
